export function fixError(msg) {
    const m = msg.match(/Firebase: Error \(auth\/([^)]+)\)/);
    if (m) {
        let err = m[1];
        err = err.replace('-', ' ');
        return err.slice(0, 1).toUpperCase() + err.slice(1);
    }
    return msg;
}
